// extracted by mini-css-extract-plugin
module.exports = {"ball-clip-rotate":"styles_ball-clip-rotate__5j6JH","rotate":"styles_rotate__3Bjmi"};